// import Main from './Main'
import ListaReboques from './components/ListaReboques'

export default [
  // { path: '/reboques', component: Main, name: 'reboques.main' },
  {path: '/reboques/lista', component: ListaReboques, name: 'reboques.lista'}
]
